import type { ModalId } from "@@/modals/context/modal-id";
import { Modal } from "@@/modals/modal";
import { ModalHeader } from "@@/modals/modal-header";
import { useModalActions } from "@@/modals/use-modal-actions";
import { ResourcePickerList } from "@@/resources/picker/resource-picker-list";
import { FlexColumn } from "@@/shared/flex-containers";
import { css, useTheme } from "@emotion/react";
import type { Resource, ResourceId, Translatable } from "@towni/common";
import { translation } from "@towni/common";

type ResourcePickerModalProps = {
    modalId: ModalId;
    title?: Translatable;
    resources: Resource[];
    onToggle: (resourceId: ResourceId) => void;
    selected: Set<ResourceId>;
    mode: "SINGLE" | "MULTI";
};
const ResourcePickerModal = (props: ResourcePickerModalProps) => {
    const theme = useTheme();
    const { title, resources, selected, onToggle, modalId, mode } = props;
    const { hide } = useModalActions(props.modalId);

    return (
        <Modal modalId={modalId}>
            <FlexColumn
                fillParentWidth
                crossAxis="flex-start"
                background={{ color: theme.colors.default.background }}
                css={css`
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                `}>
                <ModalHeader
                    modalId={modalId}
                    title={
                        title ??
                        (mode === "MULTI"
                            ? translation({
                                  sv: "Välj resurser",
                                  en: "Select resources",
                              })
                            : translation({
                                  sv: "Välj resurs",
                                  en: "Select resource",
                              }))
                    }
                    topRightButton={
                        mode === "MULTI"
                            ? {
                                  _type: "TOP_RIGHT_ACTION_TEXT",
                                  text: translation({
                                      sv: "Klar",
                                      en: "Ready",
                                  }),
                                  action: () => {
                                      hide();
                                  },
                              }
                            : undefined
                    }
                />
                <ResourcePickerList
                    resources={resources}
                    onToggle={onToggle}
                    selected={selected}
                    mode={mode}
                />
            </FlexColumn>
        </Modal>
    );
};

export { ResourcePickerModal };
